import { useState, useEffect } from 'react';
import { getUserLocation, getStoredLocation, storeLocation, clearStoredLocation } from '../utils/location';

export const useLocation = () => {
  const [locationState, setLocationState] = useState({
    city: null,
    isLoading: true,
    error: null,
    hasPermission: null,
  });

  const fetchLocation = async () => {
    setLocationState((prev) => ({ ...prev, isLoading: true }));
    clearStoredLocation();
    try {
      const location = await getUserLocation();
      storeLocation(location);
      setLocationState({
        city: location.city || 'Your Location',
        isLoading: false,
        error: null,
        hasPermission: true,
      });
    } catch (error) {
      setLocationState({
        city: null,
        isLoading: false,
        error: error.message,
        hasPermission: false,
      });
    }
  };

  useEffect(() => {
    const stored = getStoredLocation();
    if (stored) {
      setLocationState({
        city: stored.city || 'Your Location',
        isLoading: false,
        error: null,
        hasPermission: true,
      });
    } else {
      // No stored location – the LocationModal handles city selection on startup.
      setLocationState({ city: null, isLoading: false, error: null, hasPermission: null });
    }
  }, []);

  return { ...locationState, refreshLocation: fetchLocation };
};
